export const SET_COMMANDES = 'SET_COMMANDES'
export const FETCH_COMMANDES = 'FETCH_COMMANDES'
export const MESSAGE_COMMANDE = 'MESSAGE_COMMANDE'
